import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Wallet, Eye, Send } from 'lucide-react';
import { cn } from '../../lib/utils';

export const WalletCard = ({
  userId,
  userName,
  balance,
  totalCredits,
  totalDebits,
  formatCurrency,
  onViewExtract,
  onTransfer,
  isOwnWallet = false,
  compact = false,
}) => {
  const isPositive = balance > 0;
  const isNegative = balance < 0;

  if (compact) {
    return (
      <div 
        onClick={() => onViewExtract?.(userId, userName)}
        className="flex items-center gap-2 p-2 bg-slate-800/50 rounded-lg cursor-pointer hover:bg-slate-700/50 transition-colors"
      >
        <div className={cn(
          'p-1.5 rounded-full',
          isPositive ? 'bg-green-500/20' : isNegative ? 'bg-red-500/20' : 'bg-slate-700'
        )}>
          <Wallet className={cn(
            'w-4 h-4',
            isPositive ? 'text-green-400' : isNegative ? 'text-red-400' : 'text-slate-400'
          )} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-white truncate">{userName}</p>
          <p className="text-xs text-slate-400">
            Créditos: {formatCurrency(totalCredits)}
          </p>
        </div>
        <div className="text-right">
          <p className={cn(
            'text-sm font-medium',
            isPositive ? 'text-green-400' : isNegative ? 'text-red-400' : 'text-slate-300'
          )}>
            {formatCurrency(balance)}
          </p>
          <p className="text-xs text-slate-500">saldo</p>
        </div>
      </div>
    );
  }

  return (
    <Card className="bg-slate-800/50 border-slate-700">
      <CardContent className="p-4">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className={cn(
              'p-2 rounded-full',
              isPositive ? 'bg-green-500/20' : isNegative ? 'bg-red-500/20' : 'bg-slate-700'
            )}>
              <Wallet className={cn(
                'w-5 h-5',
                isPositive ? 'text-green-400' : isNegative ? 'text-red-400' : 'text-slate-400'
              )} />
            </div>
            <div>
              <p className="text-white font-medium">{userName}</p>
              {isOwnWallet && (
                <span className="text-xs text-orange-400">Sua carteira</span>
              )}
            </div>
          </div>
          <div className="text-right">
            <p className="text-xs text-slate-400">Saldo</p>
            <p className={cn(
              'text-lg font-bold',
              isPositive ? 'text-green-400' : isNegative ? 'text-red-400' : 'text-slate-300'
            )}>
              {formatCurrency(balance)}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 text-sm mb-3">
          <div className="bg-green-500/10 rounded-lg p-2">
            <p className="text-xs text-green-400">Total créditos</p>
            <p className="text-green-300 font-medium">{formatCurrency(totalCredits)}</p>
          </div>
          <div className="bg-red-500/10 rounded-lg p-2">
            <p className="text-xs text-red-400">Total débitos</p>
            <p className="text-red-300 font-medium">{formatCurrency(totalDebits)}</p>
          </div>
        </div>

        <div className="flex gap-2">
          <Button 
            variant="outline" 
            size="sm"
            onClick={() => onViewExtract?.(userId, userName)}
            className="flex-1 text-xs"
          >
            <Eye className="w-3 h-3 mr-1" />
            Ver Extrato
          </Button>
          {isPositive && (
            <Button 
              variant="outline" 
              size="sm"
              onClick={() => onTransfer?.(userId)}
              className="flex-1 text-xs"
            >
              <Send className="w-3 h-3 mr-1" />
              Transferir
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default WalletCard;
